"use client";

import { Theme } from "@/types/general";
import { useEffect } from "react";

type Props = {
  theme: Theme;
};

export const ThemeColorsClient = ({ theme }: Props) => {
  useEffect(() => {
    if (theme === "ton") {
      import("@stone-payments/jade-design-tokens/ton/color.css");
    } else {
      import("@stone-payments/jade-design-tokens/stone-rebrand/color.css");
    }
  }, [theme]);

  return null;
};
